import React from "react";
import {
  rectSwappingStrategy,
  SortableContext,
  sortableKeyboardCoordinates,
} from "@dnd-kit/sortable";
import {
  closestCenter,
  DndContext,
  DragEndEvent,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  UniqueIdentifier,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

interface SortableSectionsProps<
  T extends UniqueIdentifier | { id: UniqueIdentifier },
> {
  handleDragEnd: (event: DragEndEvent) => void;
  sortedItems: T[];
}

export const SortableSections = <
  T extends UniqueIdentifier | { id: UniqueIdentifier },
>({
  handleDragEnd,
  sortedItems,
  children,
}: React.PropsWithChildren<SortableSectionsProps<T>>) => {
  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 100,
        tolerance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={sortedItems} strategy={rectSwappingStrategy}>
        {children}
      </SortableContext>
    </DndContext>
  );
};
